<template>
  <div class="activityData" style="background: #f0f2f5">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>营销</el-breadcrumb-item>
      <el-breadcrumb-item>活动</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/activityList' }">活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动数据</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 商城订单 项目订单 快捷操作 会员数据概况 -->
    <div class="topSquare boxLayout">
      <h3 class="title-t mg-b-30">使用数据</h3>
      <div class="analysis flex space-around" v-if="Object.keys(dataCount).length > 0">
        <div class="text-center">
          <h6 class="font-12 color-999">活动名额</h6>
          <p class="font-30">{{ dataCount.number == null ? 0 : dataCount.number }}</p>
        </div>
        <div class="text-center">
          <h6 class="font-12 color-999">报名人数</h6>
          <p class="font-30">{{ dataCount.apply_num || 0 }}</p>
        </div>
        <div class="text-center">
          <h6 class="font-12 color-999">待审核</h6>
          <p class="font-30">{{ dataCount.pending || 0 }}</p>
        </div>
        <div class="text-center">
          <h6 class="font-12 color-999">审核通过</h6>
          <p class="font-30">{{ dataCount.approved || 0 }}</p>
        </div>
        <div class="text-center">
          <h6 class="font-12 color-999">审核不通过</h6>
          <p class="font-30">{{ dataCount.rejected || 0 }}</p>
        </div>
        <div class="text-center">
          <h6 class="font-12 color-999">已确认</h6>
          <p class="font-30">{{ dataCount.confirmed || 0 }}</p>
        </div>
        <div class="text-center">
          <h6 class="font-12 color-999">待确认</h6>
          <p class="font-30">{{ dataCount.unconfirmed || 0 }}</p>
        </div>
        <div class="text-center">
          <h6 class="font-12 color-999">已到场</h6>
          <p class="font-30">{{ dataCount.signed_num || 0 }}</p>
        </div>
        <div class="text-center">
          <h6 class="font-12 color-999">扫码签到</h6>
          <p class="font-12 mg-t-10" @click="show = true" style="cursor: pointer; color: blueviolet">点击查看二维码</p>
        </div>
      </div>

      <div class="dataTable">
        <!-- 验收要求: 签到记录不再单独一个 tab, 到场状态合进报名表 -->
        <div>
          <p class="text-right">
            <!-- 需求 2.2: 支持后台录入线下报名 -->
            <el-button size="mini" type="primary" class="mg-b-10" @click="openOfflineAdd"
              >新增线下报名</el-button
            >
            <el-button size="mini" class="mg-b-10" @click="exportList">导出</el-button>
          </p>
          <el-table :data="tableData.data" style="width: 100%" border>
            <el-table-column prop="create_time" label="报名时间" sortable align="center" width="160">
            </el-table-column>
            <el-table-column prop="date" label="报名人信息" align="center" width="180">
              <template slot-scope="scope">
                <router-link v-if="scope.row.user && scope.row.user.uuid" :to="'/customerInfo?uuid=' + scope.row.user.uuid">
                  <div class="nickAndAvatar">
                    <el-image :src="scope.row.user.avatar"></el-image>
                    <p>
                      <span>{{ scope.row.name || "暂无" }}</span> <br />
                      <span>{{ scope.row.mobile }}</span>
                    </p>
                  </div>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column prop="apply_setting" label="报名信息" align="center" min-width="180">
              <template slot-scope="scope">
                <template v-if="scope.row.apply_setting && scope.row.apply_setting.length > 0">
                  <div
                    v-for="(item, i) in scope.row.apply_setting"
                    :key="i"
                    style="text-align: left; margin-bottom: 4px"
                  >
                    <span v-if="item.name">{{ item.name }}：</span>
                    <span>{{ item.value }}</span>
                  </div>
                </template>
                <span v-else class="color-999">—</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="报名状态" sortable align="center" width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待审核</span>
                <span v-else-if="scope.row.status == 2" style="color: #2ed477">审核通过</span>
                <span v-else-if="scope.row.status == 3" style="color: red">审核不通过</span>
                <span v-if="scope.row.is_backup == 1" style="color: #e6a23c">（候补）</span>
              </template>
            </el-table-column>
            <!-- 客户确认状态: 只有审核通过的才谈得上确认 -->
            <el-table-column label="客户确认状态" align="center" width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.status != 2" class="color-999">——</span>
                <span v-else-if="scope.row.confirm_status == 1" style="color: #2ed477">已确认</span>
                <span v-else style="color: #e6a23c">待确认</span>
              </template>
            </el-table-column>
            <el-table-column label="客户是否到场" align="center" width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.status != 2" class="color-999">——</span>
                <span v-else-if="scope.row.is_sign_in == 1" style="color: #2ed477">是</span>
                <span v-else>否</span>
              </template>
            </el-table-column>
            <el-table-column label="邀请人" align="center" width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.inviter">
                  <span>{{ scope.row.inviter.name || "暂无昵称" }}</span> <br />
                  <span>{{ scope.row.inviter.mobile }}</span>
                </div>
                <span v-else class="color-999">——</span>
              </template>
            </el-table-column>
            <el-table-column prop="op_at" label="审核时间" align="center" width="160">
              <template slot-scope="scope">
                <span v-if="scope.row.op_at">{{ scope.row.op_at }}</span>
                <span v-else class="color-999">——</span>
              </template>
            </el-table-column>
            <el-table-column prop="apply_num" label="报名次数" align="center" width="90"> </el-table-column>
            <el-table-column label="操作" :align="'center'" fixed="right" width="150">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.status == 1" @click="pass(scope.row)">审核通过</el-button>
                <el-button type="text" v-if="scope.row.status == 1" @click="refuse(scope.row)">审核不通过</el-button>
                <!-- 到场/取消到场, 后台可手工改 -->
                <el-button type="text" v-if="scope.row.status == 2 && scope.row.is_sign_in != 1" @click="setArrive(scope.row, 1)"
                  >客户到场</el-button
                >
                <el-button type="text" v-if="scope.row.status == 2 && scope.row.is_sign_in == 1" @click="setArrive(scope.row, 2)"
                  >客户不到场</el-button
                >
                <el-button type="text" v-if="scope.row.status == 3" @click="checkInfo(scope.row)">审核记录</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="tableData.total"
            :per_page="tableData.per_page"
            :current_page="tableData.current_page"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="show" width="30%" center>
      <div class="qrCode">
        <!-- 注意: img 的 src 不走 axios 拦截器, 不能写死 time.api.boyalife.cn,
             否则测试环境的后台会去请求正式环境, 扫出来的码指向正式小程序 -->
        <img :src="signQrUrl" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="show = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 需求 2.2: 后台录入线下报名。手机号必须是已注册的会员, 接口按手机号反查用户 -->
    <el-dialog title="新增线下报名" :visible.sync="offlineShow" width="520px">
      <el-form :model="offlineForm" label-width="120px">
        <el-form-item label="报名人手机号" required>
          <el-input
            v-model="offlineForm.mobile"
            maxlength="11"
            placeholder="请输入已注册的会员手机号"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-for="(item, index) in offlineForm.setting"
          :key="item.uuid"
          :label="item.name"
        >
          <!-- 单选 -->
          <el-radio-group v-if="item.type == 1" v-model="offlineForm.setting[index].value">
            <el-radio v-for="opt in item.options" :key="opt.uuid" :label="opt.uuid">{{
              opt.name
            }}</el-radio>
          </el-radio-group>
          <!-- 多选 -->
          <el-checkbox-group
            v-else-if="item.type == 2"
            v-model="offlineForm.setting[index].value"
          >
            <el-checkbox v-for="opt in item.options" :key="opt.uuid" :label="opt.uuid">{{
              opt.name
            }}</el-checkbox>
          </el-checkbox-group>
          <!-- 日期 -->
          <el-date-picker
            v-else-if="item.type == 3"
            v-model="offlineForm.setting[index].value"
            type="date"
            value-format="yyyy/MM/dd"
            :placeholder="item.tip || '选择日期'"
          ></el-date-picker>
          <!-- 数字 / 文本 / 其他一律按文本录入 -->
          <el-input
            v-else
            v-model="offlineForm.setting[index].value"
            :placeholder="item.tip || '请输入'"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="offlineShow = false">取 消</el-button>
        <el-button type="primary" :loading="offlineSaving" @click="submitOffline"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import pagination from "../../../components/pagination.vue";
  export default {
    name: "activityData",
    components: {
      pagination,
    },
    computed: {
      // 走环境变量, 保证测试环境的后台生成的是测试环境小程序码
      signQrUrl() {
        return `${process.env.VUE_APP_API_BASE_URL}/v1/cms/Activity/qrcode?uuid=${this.$route.query.uuid}`;
      },
    },
    data() {
      return {
        show: false,
        offlineShow: false,
        offlineSaving: false,
        // setting 从活动详情取, 与小程序报名填的是同一套信息项
        offlineForm: { mobile: "", setting: [] },
        // 验收要求: 签到记录不再单独成表, 到场状态并进报名表, 所以去掉 tab 和第二份表格数据
        tableData: {
          data: [],
          per_page: 10,
          current_page: 1,
          total: 0,
        },
        dataCount: {},
      };
    },
    created() {
      this.getList();
      this.getCount();
    },
    methods: {
      // 设置/取消客户到场。后台可手工改, 与小程序扫码签到写的是同一个状态
      setArrive(row, isArrive) {
        const tip = isArrive == 1 ? "确认该客户已到场吗？" : "确认把该客户改为未到场吗？";
        this.$confirm(tip, "提示", { type: "warning" })
          .then(() => {
            this.axios({
              method: "put",
              headers: {
                "Content-Type": "application/json",
                "X-Access-Token": this.storage.get("__token"),
                Authorization: `Bearer ${this.storage.get("__token")}`,
              },
              data: { is_sign_in: isArrive },
              url: ` https://time.api.boyalife.cn/v1/cms/ActivityApply/arrive/${row.uuid}`,
            })
              .then(() => {
                this.$message.success(isArrive == 1 ? "已设为到场" : "已取消到场");
                this.getList();
                this.getCount();
              })
              .catch((err) => {
                this.$message.error(this.pickErr(err));
              });
          })
          .catch(() => {});
      },

      // 导出
      exportList() {
        this.axios({
          method: "get", //请求方法
          responseType: "blob",
          headers: {
            "Content-Type": "text/html;charset=UTF-8",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },

          url: ` https://time.api.boyalife.cn/v1/cms/ActivityApply/export/${this.$route.query.uuid}`,
        })
          .then((response) => {
            const blob = new Blob([response.data]);
            // 创建a标签进行下载
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            let currentTime = new Date();
            let year = currentTime.getFullYear();
            let month = currentTime.getMonth() + 1;
            let day = currentTime.getDate();
            let formattedDate = `${year}/${month.toString().padStart(2, "0")}/${day.toString().padStart(2, "0")}`;
            link.download = "报名审核列表" + "_" + formattedDate + ".xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$message.success("导出成功！");
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      getCount() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },

          url: ` https://time.api.boyalife.cn/v1/cms/ActivityApply/count?uuid=${this.$route.query.uuid}&page_index=${this.tableData.current_page}&page_size=${this.tableData.per_page}`,
        })
          .then((res) => {
            this.dataCount = res.data.result;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      getList() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },

          url: ` https://time.api.boyalife.cn/v1/cms/ActivityApply?activity_uuid=${this.$route.query.uuid}&page_index=${this.tableData.current_page}&page_size=${this.tableData.per_page}`,
        })
          .then((res) => {
            this.tableData = res.data.result;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      // 打开线下报名弹窗, 顺带把该活动配置的报名信息项拉过来
      openOfflineAdd() {
        this.offlineForm = { mobile: "", setting: [] };
        this.offlineShow = true;
        this.axios({
          method: "get",
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/Activity/${this.$route.query.uuid}`,
        })
          .then((res) => {
            const setting = (res.data.result || {}).setting || [];
            this.offlineForm.setting = setting.map((item) => ({
              ...item,
              // 多选要用数组, 其余用字符串, 与小程序提交的结构保持一致
              value: item.type == 2 ? [] : "",
            }));
          })
          .catch((err) => {
            this.$message.error(this.pickErr(err));
          });
      },
      submitOffline() {
        const mobile = (this.offlineForm.mobile || "").trim();
        if (!/^1\d{10}$/.test(mobile)) {
          return this.$message.error("请输入正确的手机号");
        }
        const apply_setting = this.offlineForm.setting.map((item) => ({
          uuid: item.uuid,
          value: item.value,
        }));
        this.offlineSaving = true;
        this.axios({
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          data: {
            activity_uuid: this.$route.query.uuid,
            mobile: mobile,
            apply_setting: JSON.stringify(apply_setting),
          },
          url: ` https://time.api.boyalife.cn/v1/cms/ActivityApply`,
        })
          .then(() => {
            this.offlineSaving = false;
            this.offlineShow = false;
            this.$message.success("已新增线下报名");
            this.getList();
            this.getCount();
          })
          .catch((err) => {
            this.offlineSaving = false;
            // 手机号未注册、重复报名这类业务提示都从这里出来
            this.$message.error(this.pickErr(err));
          });
      },
      pickErr(err) {
        try {
          return err.response.data.error.message;
        } catch (e) {
          return typeof err === "string" ? err : "操作失败";
        }
      },
      pass(row) {
        this.$confirm("确定审核通过该用户的活动报名信息吗?", "审核通过确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.axios({
            method: "put", //请求方法
            headers: {
              "Content-Type": "application/json",
              "X-Access-Token": this.storage.get("__token"),
              Authorization: `Bearer ${this.storage.get("__token")}`,
            },
            url: ` https://time.api.boyalife.cn/v1/cms/ActivityApply/approve/${row.uuid}`,
          })
            .then((res) => {
              this.$message.success("审核成功！");
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err.response.data.error.message);
            });
        });
      },
      refuse(row) {
        this.$prompt("确定不通过该用户的报名信息吗？", "审核不通过确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          inputPlaceholder: "请输入不通过理由",
          inputType: "textarea",
          inputPattern: /[a-zA-Z0-9_\u4e00-\u9fa5]+/,
          inputErrorMessage: "理由不能为空",
        }).then(({ value }) => {
          this.axios({
            method: "put", //请求方法
            headers: {
              "Content-Type": "application/json",
              "X-Access-Token": this.storage.get("__token"),
              Authorization: `Bearer ${this.storage.get("__token")}`,
            },
            data: {
              reason: value,
            },
            url: ` https://time.api.boyalife.cn/v1/cms/ActivityApply/reject/${row.uuid}`,
          })
            .then((res) => {
              this.$message.success("审核成功！");
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err.response.data.error.message);
            });
        });
      },
      checkInfo(row) {
        let html = `
        <h5 class="mg-l-30 mg-b-10">操作人: ${row.op_by_user}</h5>
        <h5 class="mg-l-30 mg-b-10">操作时间：${row.op_at}</h5>
        <h5 class="mg-l-30 mg-b-10">审核结果：审核不通过</h5>
        <h5 class="mg-l-30 mg-b-10">不通过原因：${row.reason}</h5>
      `;
        this.$confirm(html, "查看审核记录", {
          confirmButtonText: "确认",
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
        })
          .then(() => {})
          .catch(() => {});
      },

      handleSizeChange(v) {
        this.tableData.per_page = v;
        this.getList();
      },
      handleCurrentChange(v) {
        this.tableData.current_page = v;
        this.getList();
      },
    },
  };
</script>
<style scoped>
  .dataTable {
    box-shadow: none;
    border-radius: 0;
    margin-top: 50px;
  }
  .dataTable .tabs {
    position: static;
  }
  .dataTable .tabs p {
    padding: 10px 20px;
    position: relative;
    cursor: pointer;
  }
  .qrCode {
    text-align: center;
  }
  .qrCode img {
    width: 200px;
    height: 200px;
  }
  .dataTable .tabs p:after {
    content: "";
    width: 100%;
    height: 2px;
    background: none;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .dataTable .tabs p.on {
    color: #409eff;
  }
  .dataTable .tabs p.on:after {
    background: #409eff;
  }
  /deep/ .el-message-box__message img {
    width: 100px;
    height: 100px;
  }
</style>
